import React from 'react';
import { useEffect, useState } from 'react';
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components';
import { Tabs } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/navigation';
import PdfPreview from '@/components/PDFPreview'
import styles from './index.module.less'

const COMMODITY_INFO_TYPE = {
  /**
	 * 图文.
	 */
	TYPE_TXT: 'attachContent',
	/**
	 * PDF.
	 */
	TYPE_PDF: 'attachPDF',
	/**
	 * 视频.
	 */
	TYPE_VIDEO: 'attachVideo',
	/**
	 * 设计大师.
	 */
	TYPE_DESIGN: 'attachURL',
	/**
	 * 商品列表
	 */
	TYPE_COMMODITY: 'TYPE_COMMODITY',
	/**
	 * 商品参数
	 */
	TYPE_PRODUCT: 'TYPE_PRODUCT',
	/**
	 * 概览
	 */
	TYPE_ALL: 'TYPE_ALL',
};

export default function ChooseMaterialModal ({
  open = false,
  onClose = () => {},
  info = {},
  title = '',
})  {
  const [chooseTab, setChooseTab] = useState<any>({});

  useEffect(() => {
    setChooseTab(info?.attachList?.[0] || {});
  }, [])

  const changeTabs = (key: string) => {
    const item: any = info?.attachList?.find((item: any, index: number) => String(index) === key) || {};
    if (item?.contentType === COMMODITY_INFO_TYPE['TYPE_DESIGN']) {
      window.open(item?.attachPath);
      return;
    }
    setChooseTab(item);
  };

  return (
    <SDrawerOrModal
      mode="drawer"
      open={open}
      onCancel={() => onClose()}
      width={600}
      title={title}
      antdProps={{
        footer: null
      }}
    >
      <div className={styles.spuDetailModal}>
        <Swiper
          navigation={true}
          modules={[Navigation]}
          style={{ width: '100%', height: '320px' }}
          loop
        >
          {info?.imageUrls?.map?.((url, i) => {
            return (
              <SwiperSlide key={`slide_${i}`}>
                <div className={styles.bg} style={{ backgroundImage: `url(${url})` }}></div>
              </SwiperSlide>
            )
          })}
        </Swiper>
        <Tabs
          more={{ icon: null }}
          tabBarExtraContent={{ right: null, left: null }}
          activeKey={chooseTab?.id}
          onChange={changeTabs}
          items={
            info?.attachList?.length !== 0 ? info?.attachList?.map((tab: any, index: number) => (
              {
                key: String(index),
                label: tab.attachName,
              }
            )) : []
          }
        >
        </Tabs>
        <div className={styles.detailInfo}>
          <div className={styles.commodityBox} style={{ display: chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_PDF'] ? 'block' : 'none' }}>
            {chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_PDF'] ? <PdfPreview url={chooseTab.attachPath || ''} /> : null}
          </div>
          <div className={styles.commodityBox} style={{ display: chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_TXT'] ? 'block' : 'none' }}>
            {chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_TXT'] ? <div dangerouslySetInnerHTML={{ __html: chooseTab.content || '' }} style={{overflow:'scroll', height: '100%'}} /> : null}
          </div>
          <div className={styles.commodityBox} style={{ display: chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_VIDEO'] ? 'block' : 'none' }}>
            {chooseTab?.contentType === COMMODITY_INFO_TYPE['TYPE_VIDEO'] ? <video style={{ width: '100%' }}  src={chooseTab.attachPath || ''} controls={true} /> : null}
          </div>
        </div>
      </div>
    </SDrawerOrModal>
  )
}